// Public copy sourced from Explore, ApplyPage and data/demos.ts; examples are not customer claims.
export const publicSite = {
  "name": "SLOE OS",
  "origin": "https://www.sloelabs.com",
  "summary": "SLOE Labs turns work into AI Agentic Applications. Its Architect shapes a working application around a business or role, with screens, agents, decisions, receipts and an upgrade path. The public gallery shows industry examples, and Sloe Guild reviews applications from prospective operators.",
  "pages": {
    "/": {
      "title": "SLOE OS by SLOE Labs Inc.",
      "description": "Turn your work into an AI Agentic Application with SLOE Labs. Explore industry examples and use the Architect to shape screens, agents, decisions and receipts around your role."
    },
    "/build": {
      "title": "The Architect | SLOE Labs",
      "description": "Describe your work to the SLOE Labs Architect and shape an AI Agentic Application with screens, agents, decisions and receipts around your business and role."
    },
    "/apply": {
      "title": "Operator application | SLOE Labs",
      "description": "Apply to become a Sloe Guild operator through SLOE Labs. Share your business and local market experience for an application reviewed individually by the team."
    },
    "/privacy": {
      "title": "Privacy | SLOE Labs",
      "description": "Read the Sloe Laboratory privacy policy, including how account information, business inputs and generated application content are handled, and how to contact support."
    },
    "/terms": {
      "title": "Terms of service | SLOE Labs",
      "description": "Read the terms of service for Sloe Laboratory and its AI application builder, including account use, generated content, service limits and contact information."
    },
    "/demo/football-agency-os": {
      "title": "Football Agency Agentic Operating System example | SLOE Labs",
      "description": "Explore the Football Agency Agentic Operating System example. Player pipelines, club matching, and deal tracking \u2014 built for the agency business."
    },
    "/demo/rugby-agency-os": {
      "title": "Rugby Agency Agentic Operating System example | SLOE Labs",
      "description": "Explore the Rugby Agency Agentic Operating System example. Player pipelines, union/club matching, and contract tracking \u2014 built for rugby representation."
    },
    "/demo/tennis-agency-os": {
      "title": "Tennis Agency Agentic Operating System example | SLOE Labs",
      "description": "Explore the Tennis Agency Agentic Operating System example. Player development, tour scheduling, and endorsement deals \u2014 built for tennis representation."
    },
    "/demo/cricket-agency-os": {
      "title": "Cricket Agency Agentic Operating System example | SLOE Labs",
      "description": "Explore the Cricket Agency Agentic Operating System example. Player pipelines, franchise-league auctions, and central-contract tracking \u2014 built for cricket representation."
    },
    "/demo/basketball-agency-os": {
      "title": "Basketball Agency Agentic Operating System example | SLOE Labs",
      "description": "Explore the Basketball Agency Agentic Operating System example. Player pipelines, league/team matching, and contract tracking \u2014 built for basketball representation."
    },
    "/demo/athletics-agency-os": {
      "title": "Athletics Agency Agentic Operating System example | SLOE Labs",
      "description": "Explore the Athletics Agency Agentic Operating System example. Athlete management, meet scheduling, and appearance deals \u2014 built for track & field representation."
    },
    "/demo/combat-sports-agency-os": {
      "title": "Combat Sports Agency Agentic Operating System example | SLOE Labs",
      "description": "Explore the Combat Sports Agency Agentic Operating System example. Fighter management, matchmaking, and bout deals \u2014 built for MMA & boxing representation."
    },
    "/demo/esports-agency-os": {
      "title": "Esports Agency Agentic Operating System example | SLOE Labs",
      "description": "Explore the Esports Agency Agentic Operating System example. Player pipelines, org/roster matching, and buyout deals \u2014 built for esports representation."
    },
    "/demo/residential-sales-os": {
      "title": "Residential Sales Agentic Operating System example | SLOE Labs",
      "description": "Explore the Residential Sales Agentic Operating System example. Listings, buyer matching, and offer tracking \u2014 built for residential brokerage."
    },
    "/demo/property-mgmt-os": {
      "title": "Property Management Agentic Operating System example | SLOE Labs",
      "description": "Explore the Property Management Agentic Operating System example. Tenancies, maintenance, and rent collection \u2014 built for property managers."
    },
    "/demo/commercial-realestate-os": {
      "title": "Commercial Real Estate Agentic Operating System example | SLOE Labs",
      "description": "Explore the Commercial Real Estate Agentic Operating System example. Office, retail, and industrial deals \u2014 built for commercial brokerage."
    },
    "/demo/construction-realestate-os": {
      "title": "Property Construction Agentic Operating System example | SLOE Labs",
      "description": "Explore the Property Construction Agentic Operating System example. Build projects, contractors, and draw schedules \u2014 built for developer-side construction."
    },
    "/demo/leasing-os": {
      "title": "Leasing Agentic Operating System example | SLOE Labs",
      "description": "Explore the Leasing Agentic Operating System example. Lettings pipelines, applicant screening, and renewals \u2014 built for residential & commercial leasing."
    },
    "/demo/development-os": {
      "title": "Property Development Agentic Operating System example | SLOE Labs",
      "description": "Explore the Property Development Agentic Operating System example. Land, feasibility, and scheme delivery \u2014 built for property developers."
    },
    "/demo/off-plan-os": {
      "title": "Off-Plan Sales Agentic Operating System example | SLOE Labs",
      "description": "Explore the Off-Plan Sales Agentic Operating System example. Unit inventory, reservations, and payment-plan tracking \u2014 built for off-plan sales."
    },
    "/demo/upstream-oilgas-os": {
      "title": "Upstream Oil & Gas Agentic Operating System example | SLOE Labs",
      "description": "Explore the Upstream Oil & Gas Agentic Operating System example. Wells, production, and JV partners \u2014 built for E&P operators."
    },
    "/demo/midstream-oilgas-os": {
      "title": "Midstream Oil & Gas Agentic Operating System example | SLOE Labs",
      "description": "Explore the Midstream Oil & Gas Agentic Operating System example. Pipelines, storage, and throughput contracts \u2014 built for midstream operators."
    },
    "/demo/downstream-oilgas-os": {
      "title": "Downstream Oil & Gas Agentic Operating System example | SLOE Labs",
      "description": "Explore the Downstream Oil & Gas Agentic Operating System example. Refining, distribution, and fuel retail \u2014 built for downstream operators."
    },
    "/demo/oilfield-services-os": {
      "title": "Oilfield Services Agentic Operating System example | SLOE Labs",
      "description": "Explore the Oilfield Services Agentic Operating System example. Service contracts, crews, and equipment \u2014 built for oilfield-services companies."
    },
    "/demo/drilling-os": {
      "title": "Drilling Agentic Operating System example | SLOE Labs",
      "description": "Explore the Drilling Agentic Operating System example. Rigs, well programs, and daily drilling reports \u2014 built for drilling contractors."
    },
    "/demo/renewables-os": {
      "title": "Renewables Agentic Operating System example | SLOE Labs",
      "description": "Explore the Renewables Agentic Operating System example. Solar, wind, and storage projects \u2014 built for renewable-energy developers & operators."
    },
    "/demo/utilities-os": {
      "title": "Utilities Agentic Operating System example | SLOE Labs",
      "description": "Explore the Utilities Agentic Operating System example. Networks, connections, and outages \u2014 built for power, water & gas utilities."
    },
    "/demo/clinics-os": {
      "title": "Clinics Agentic Operating System example | SLOE Labs",
      "description": "Explore the Clinics Agentic Operating System example. Patients, appointments, and claims \u2014 built for outpatient clinics."
    },
    "/demo/telehealth-os": {
      "title": "Telehealth Agentic Operating System example | SLOE Labs",
      "description": "Explore the Telehealth Agentic Operating System example. Virtual visits, e-prescribing, and triage \u2014 built for telehealth providers."
    },
    "/demo/dental-os": {
      "title": "Dental Agentic Operating System example | SLOE Labs",
      "description": "Explore the Dental Agentic Operating System example. Patients, treatment plans, and recalls \u2014 built for dental practices."
    },
    "/demo/mental-health-os": {
      "title": "Mental Health Agentic Operating System example | SLOE Labs",
      "description": "Explore the Mental Health Agentic Operating System example. Clients, sessions, and outcomes \u2014 built for mental-health practices."
    },
    "/demo/medical-devices-os": {
      "title": "Medical Devices Agentic Operating System example | SLOE Labs",
      "description": "Explore the Medical Devices Agentic Operating System example. Registration, distribution, and post-market \u2014 built for medical-device companies."
    },
    "/demo/pharmacy-os": {
      "title": "Pharmacy Agentic Operating System example | SLOE Labs",
      "description": "Explore the Pharmacy Agentic Operating System example. Dispensing, inventory, and claims \u2014 built for retail & community pharmacy."
    },
    "/demo/home-care-os": {
      "title": "Home Care Agentic Operating System example | SLOE Labs",
      "description": "Explore the Home Care Agentic Operating System example. Care plans, carer scheduling, and visit logs \u2014 built for home & domiciliary care."
    },
    "/demo/banking-os": {
      "title": "Banking Agentic Operating System example | SLOE Labs",
      "description": "Explore the Banking Agentic Operating System example. Onboarding, accounts, and relationship management \u2014 built for retail & business banking."
    },
    "/demo/insurance-os": {
      "title": "Insurance Agentic Operating System example | SLOE Labs",
      "description": "Explore the Insurance Agentic Operating System example. Policies, quotes, and claims \u2014 built for insurers, brokers & MGAs."
    },
    "/demo/wealth-management-os": {
      "title": "Wealth Management Agentic Operating System example | SLOE Labs",
      "description": "Explore the Wealth Management Agentic Operating System example. Clients, portfolios, and suitability \u2014 built for wealth managers & advisers."
    },
    "/demo/lending-os": {
      "title": "Lending Agentic Operating System example | SLOE Labs",
      "description": "Explore the Lending Agentic Operating System example. Applications, underwriting, and servicing \u2014 built for lenders & brokers."
    },
    "/demo/accounting-firm-os": {
      "title": "Accounting Firm Agentic Operating System example | SLOE Labs",
      "description": "Explore the Accounting Firm Agentic Operating System example. Clients, compliance jobs, and deadlines \u2014 built for accounting & audit firms."
    },
    "/demo/fintech-os": {
      "title": "Fintech Agentic Operating System example | SLOE Labs",
      "description": "Explore the Fintech Agentic Operating System example. Users, KYC, and compliance ops \u2014 built for fintech & digital-finance startups."
    },
    "/demo/payments-os": {
      "title": "Payments Agentic Operating System example | SLOE Labs",
      "description": "Explore the Payments Agentic Operating System example. Merchants, transactions, and settlement \u2014 built for payment providers & PSPs."
    },
    "/demo/corporate-law-os": {
      "title": "Corporate Law Agentic Operating System example | SLOE Labs",
      "description": "Explore the Corporate Law Agentic Operating System example. Matters, deals, and entity work \u2014 built for corporate & commercial law firms."
    },
    "/demo/litigation-os": {
      "title": "Litigation Agentic Operating System example | SLOE Labs",
      "description": "Explore the Litigation Agentic Operating System example. Cases, deadlines, and disclosure \u2014 built for litigation & dispute-resolution teams."
    },
    "/demo/immigration-law-os": {
      "title": "Immigration Law Agentic Operating System example | SLOE Labs",
      "description": "Explore the Immigration Law Agentic Operating System example. Cases, applications, and visa deadlines \u2014 built for immigration practices."
    },
    "/demo/ip-law-os": {
      "title": "IP Law Agentic Operating System example | SLOE Labs",
      "description": "Explore the IP Law Agentic Operating System example. Portfolios, filings, and renewal deadlines \u2014 built for IP & trademark practices."
    },
    "/demo/real-estate-law-os": {
      "title": "Real Estate Law Agentic Operating System example | SLOE Labs",
      "description": "Explore the Real Estate Law Agentic Operating System example. Conveyancing, transactions, and completions \u2014 built for property-law teams."
    },
    "/demo/family-law-os": {
      "title": "Family Law Agentic Operating System example | SLOE Labs",
      "description": "Explore the Family Law Agentic Operating System example. Cases, financials, and court deadlines \u2014 built for family-law practices."
    },
    "/demo/compliance-law-os": {
      "title": "Compliance Agentic Operating System example | SLOE Labs",
      "description": "Explore the Compliance Agentic Operating System example. Obligations, controls, and audits \u2014 built for compliance & regulatory teams."
    },
    "/demo/creative-agency-os": {
      "title": "Creative Agency Agentic Operating System example | SLOE Labs",
      "description": "Explore the Creative Agency Agentic Operating System example. Clients, projects, and retainers \u2014 built for creative & marketing agencies."
    },
    "/demo/content-os": {
      "title": "Content Agentic Operating System example | SLOE Labs",
      "description": "Explore the Content Agentic Operating System example. Editorial calendars, production, and distribution \u2014 built for content teams."
    },
    "/demo/advertising-os": {
      "title": "Advertising Agentic Operating System example | SLOE Labs",
      "description": "Explore the Advertising Agentic Operating System example. Campaigns, media plans, and performance \u2014 built for ad & media agencies."
    },
    "/demo/pr-os": {
      "title": "PR Agentic Operating System example | SLOE Labs",
      "description": "Explore the PR Agentic Operating System example. Media relations, coverage, and reputation \u2014 built for PR & comms teams."
    },
    "/demo/social-os": {
      "title": "Social Media Agentic Operating System example | SLOE Labs",
      "description": "Explore the Social Media Agentic Operating System example. Content calendars, community, and social performance \u2014 built for social teams."
    },
    "/demo/production-media-os": {
      "title": "Media Production Agentic Operating System example | SLOE Labs",
      "description": "Explore the Media Production Agentic Operating System example. Productions, crew, and budgets \u2014 built for film, video & content production."
    },
    "/demo/influencer-os": {
      "title": "Influencer Agentic Operating System example | SLOE Labs",
      "description": "Explore the Influencer Agentic Operating System example. Talent, deals, and campaign delivery \u2014 built for influencer agencies & talent managers."
    },
    "/demo/d2c-brands-os": {
      "title": "D2C Brand Agentic Operating System example | SLOE Labs",
      "description": "Explore the D2C Brand Agentic Operating System example. Orders, inventory, and retention \u2014 built for direct-to-consumer brands."
    },
    "/demo/marketplaces-os": {
      "title": "Marketplace Seller Agentic Operating System example | SLOE Labs",
      "description": "Explore the Marketplace Seller Agentic Operating System example. Listings, multi-channel orders, and seller health \u2014 built for marketplace sellers."
    },
    "/demo/omnichannel-retail-os": {
      "title": "Omnichannel Retail Agentic Operating System example | SLOE Labs",
      "description": "Explore the Omnichannel Retail Agentic Operating System example. Stores, online, and unified inventory \u2014 built for omnichannel retailers."
    },
    "/demo/fashion-os": {
      "title": "Fashion Agentic Operating System example | SLOE Labs",
      "description": "Explore the Fashion Agentic Operating System example. Collections, wholesale, and seasons \u2014 built for fashion & apparel brands."
    },
    "/demo/subscription-os": {
      "title": "Subscription Agentic Operating System example | SLOE Labs",
      "description": "Explore the Subscription Agentic Operating System example. Plans, billing, and churn \u2014 built for subscription & membership businesses."
    },
    "/demo/wholesale-os": {
      "title": "Wholesale Agentic Operating System example | SLOE Labs",
      "description": "Explore the Wholesale Agentic Operating System example. Accounts, orders, and trade terms \u2014 built for wholesale & distribution."
    },
    "/demo/restaurants-os": {
      "title": "Restaurant Agentic Operating System example | SLOE Labs",
      "description": "Explore the Restaurant Agentic Operating System example. Covers, kitchen, and margins \u2014 built for restaurants & F&B groups."
    },
    "/demo/hotels-os": {
      "title": "Hotel Agentic Operating System example | SLOE Labs",
      "description": "Explore the Hotel Agentic Operating System example. Bookings, rates, and guest journey \u2014 built for hotels & serviced properties."
    },
    "/demo/events-os": {
      "title": "Events Agentic Operating System example | SLOE Labs",
      "description": "Explore the Events Agentic Operating System example. Bookings, suppliers, and run-of-show \u2014 built for event & venue businesses."
    },
    "/demo/catering-os": {
      "title": "Catering Agentic Operating System example | SLOE Labs",
      "description": "Explore the Catering Agentic Operating System example. Quotes, production, and delivery \u2014 built for catering & food-service operators."
    },
    "/demo/travel-os": {
      "title": "Travel Agentic Operating System example | SLOE Labs",
      "description": "Explore the Travel Agentic Operating System example. Itineraries, bookings, and supplier management \u2014 built for travel agencies & TMCs."
    },
    "/demo/tourism-os": {
      "title": "Tourism Agentic Operating System example | SLOE Labs",
      "description": "Explore the Tourism Agentic Operating System example. Tours, activities, and guides \u2014 built for tour & activity operators (DMCs)."
    },
    "/demo/freight-os": {
      "title": "Freight Agentic Operating System example | SLOE Labs",
      "description": "Explore the Freight Agentic Operating System example. Shipments, rates, and documentation \u2014 built for freight forwarders & NVOCCs."
    },
    "/demo/last-mile-os": {
      "title": "Last-Mile Agentic Operating System example | SLOE Labs",
      "description": "Explore the Last-Mile Agentic Operating System example. Routes, drivers, and proof-of-delivery \u2014 built for last-mile delivery operators."
    },
    "/demo/warehousing-os": {
      "title": "Warehousing Agentic Operating System example | SLOE Labs",
      "description": "Explore the Warehousing Agentic Operating System example. Inbound, storage, and fulfilment \u2014 built for warehouses & 3PLs."
    },
    "/demo/fleet-os": {
      "title": "Fleet Agentic Operating System example | SLOE Labs",
      "description": "Explore the Fleet Agentic Operating System example. Vehicles, drivers, and maintenance \u2014 built for fleet & transport operators."
    },
    "/demo/supply-chain-os": {
      "title": "Supply Chain Agentic Operating System example | SLOE Labs",
      "description": "Explore the Supply Chain Agentic Operating System example. Demand, supply, and supplier risk \u2014 built for supply-chain & procurement teams."
    },
    "/demo/customs-os": {
      "title": "Customs Agentic Operating System example | SLOE Labs",
      "description": "Explore the Customs Agentic Operating System example. Declarations, classification, and clearance \u2014 built for customs brokers."
    },
    "/demo/industrial-mfg-os": {
      "title": "Industrial Manufacturing Agentic Operating System example | SLOE Labs",
      "description": "Explore the Industrial Manufacturing Agentic Operating System example. Work orders, production, and quality \u2014 built for industrial manufacturers."
    },
    "/demo/automotive-mfg-os": {
      "title": "Automotive Agentic Operating System example | SLOE Labs",
      "description": "Explore the Automotive Agentic Operating System example. Programs, parts, and IATF quality \u2014 built for automotive manufacturers & suppliers."
    },
    "/demo/electronics-mfg-os": {
      "title": "Electronics Agentic Operating System example | SLOE Labs",
      "description": "Explore the Electronics Agentic Operating System example. BOMs, SMT production, and compliance \u2014 built for electronics manufacturers (EMS)."
    },
    "/demo/food-production-os": {
      "title": "Food Production Agentic Operating System example | SLOE Labs",
      "description": "Explore the Food Production Agentic Operating System example. Batches, food-safety, and traceability \u2014 built for food & beverage manufacturers."
    },
    "/demo/textiles-mfg-os": {
      "title": "Textiles Agentic Operating System example | SLOE Labs",
      "description": "Explore the Textiles Agentic Operating System example. Orders, production, and compliance \u2014 built for textile & apparel manufacturers."
    },
    "/demo/machinery-mfg-os": {
      "title": "Machinery Agentic Operating System example | SLOE Labs",
      "description": "Explore the Machinery Agentic Operating System example. Engineer-to-order, builds, and after-sales \u2014 built for machinery & equipment makers."
    },
    "/demo/residential-build-os": {
      "title": "Residential Build Agentic Operating System example | SLOE Labs",
      "description": "Explore the Residential Build Agentic Operating System example. Jobs, trades, and budgets \u2014 built for home builders & residential contractors."
    },
    "/demo/commercial-build-os": {
      "title": "Commercial Build Agentic Operating System example | SLOE Labs",
      "description": "Explore the Commercial Build Agentic Operating System example. Projects, packages, and contracts \u2014 built for commercial main contractors."
    },
    "/demo/civil-construction-os": {
      "title": "Civil Engineering Agentic Operating System example | SLOE Labs",
      "description": "Explore the Civil Engineering Agentic Operating System example. Infrastructure works, plant, and measurement \u2014 built for civil & infrastructure contractors."
    },
    "/demo/trades-os": {
      "title": "Trades Agentic Operating System example | SLOE Labs",
      "description": "Explore the Trades Agentic Operating System example. Jobs, quotes, and scheduling \u2014 built for electrical, plumbing & specialist trades."
    },
    "/demo/construction-pm-os": {
      "title": "Construction PM Agentic Operating System example | SLOE Labs",
      "description": "Explore the Construction PM Agentic Operating System example. Programme, cost, and risk \u2014 built for construction PMs, QS & consultants."
    },
    "/demo/architecture-os": {
      "title": "Architecture Agentic Operating System example | SLOE Labs",
      "description": "Explore the Architecture Agentic Operating System example. Projects, stages, and approvals \u2014 built for architecture & design practices."
    },
    "/demo/schools-os": {
      "title": "Schools Agentic Operating System example | SLOE Labs",
      "description": "Explore the Schools Agentic Operating System example. Admissions, students, and safeguarding \u2014 built for K-12 schools."
    },
    "/demo/higher-ed-os": {
      "title": "Higher Education Agentic Operating System example | SLOE Labs",
      "description": "Explore the Higher Education Agentic Operating System example. Recruitment, students, and outcomes \u2014 built for universities & colleges."
    },
    "/demo/edtech-os": {
      "title": "EdTech Agentic Operating System example | SLOE Labs",
      "description": "Explore the EdTech Agentic Operating System example. Learners, content, and engagement \u2014 built for EdTech & online-learning companies."
    },
    "/demo/corporate-training-os": {
      "title": "Corporate Training Agentic Operating System example | SLOE Labs",
      "description": "Explore the Corporate Training Agentic Operating System example. Programs, cohorts, and compliance training \u2014 built for L&D & training providers."
    },
    "/demo/tutoring-os": {
      "title": "Tutoring Agentic Operating System example | SLOE Labs",
      "description": "Explore the Tutoring Agentic Operating System example. Students, tutors, and sessions \u2014 built for tutoring centres & agencies."
    },
    "/demo/academies-os": {
      "title": "Academies Agentic Operating System example | SLOE Labs",
      "description": "Explore the Academies Agentic Operating System example. Members, programs, and progression \u2014 built for sports & skills academies."
    },
    "/demo/consulting-os": {
      "title": "Consulting Agentic Operating System example | SLOE Labs",
      "description": "Explore the Consulting Agentic Operating System example. Engagements, utilization, and delivery \u2014 built for consulting firms."
    },
    "/demo/recruiting-os": {
      "title": "Recruiting Agentic Operating System example | SLOE Labs",
      "description": "Explore the Recruiting Agentic Operating System example. Candidates, roles, and placements \u2014 built for recruitment & staffing agencies."
    },
    "/demo/hr-os": {
      "title": "HR Agentic Operating System example | SLOE Labs",
      "description": "Explore the HR Agentic Operating System example. People, payroll, and compliance \u2014 built for HR teams & HR consultancies."
    },
    "/demo/design-os": {
      "title": "Design Studio Agentic Operating System example | SLOE Labs",
      "description": "Explore the Design Studio Agentic Operating System example. Clients, projects, and assets \u2014 built for design & product studios."
    },
    "/demo/charities-os": {
      "title": "Charities Agentic Operating System example | SLOE Labs",
      "description": "Explore the Charities Agentic Operating System example. Donors, fundraising, and impact \u2014 built for charities & nonprofits."
    },
    "/demo/foundations-os": {
      "title": "Foundations Agentic Operating System example | SLOE Labs",
      "description": "Explore the Foundations Agentic Operating System example. Grants, applicants, and impact \u2014 built for grant-making foundations."
    },
    "/demo/ngos-os": {
      "title": "NGO Agentic Operating System example | SLOE Labs",
      "description": "Explore the NGO Agentic Operating System example. Programs, grants, and field operations \u2014 built for NGOs & development organisations."
    },
    "/demo/faith-os": {
      "title": "Faith Organisation Agentic Operating System example | SLOE Labs",
      "description": "Explore the Faith Organisation Agentic Operating System example. Members, giving, and events \u2014 built for faith & religious organisations."
    },
    "/demo/community-os": {
      "title": "Community Organisation Agentic Operating System example | SLOE Labs",
      "description": "Explore the Community Organisation Agentic Operating System example. Members, services, and volunteers \u2014 built for community & social organisations."
    },
    "/demo/advocacy-os": {
      "title": "Advocacy Agentic Operating System example | SLOE Labs",
      "description": "Explore the Advocacy Agentic Operating System example. Campaigns, supporters, and influence \u2014 built for advocacy & campaigning organisations."
    },
    "/demo/realty-os": {
      "title": "Realty Agentic Operating System example | SLOE Labs",
      "description": "Explore the Realty Agentic Operating System example. Brokerage and off-plan sales \u2014 built regulatory-native for the Gulf."
    },
    "/demo/property-management-os": {
      "title": "Property Management Agentic Operating System example | SLOE Labs",
      "description": "Explore the Property Management Agentic Operating System example. RERA compliance, OA governance, service charges \u2014 built on Bahrain Law 27/2017."
    },
    "/demo/academy-intelligence-os": {
      "title": "Academy Intelligence Agentic Operating System example | SLOE Labs",
      "description": "Explore the Academy Intelligence Agentic Operating System example. Describe, predict, act \u2014 player development across match, individual, and collective lenses."
    },
    "/demo/luxury-design-os": {
      "title": "Luxury Design Agentic Operating System example | SLOE Labs",
      "description": "Explore the Luxury Design Agentic Operating System example. Concierge-led client intake with mood boards, Style DNA, and briefing dossiers."
    },
    "/demo/pe-dealflow-os": {
      "title": "PE Dealflow Agentic Operating System example | SLOE Labs",
      "description": "Explore the PE Dealflow Agentic Operating System example. Deal pipeline, DD workspace, and portfolio intelligence for boutique PE firms."
    },
    "/demo/trade-docs-os": {
      "title": "Trade Docs Agentic Operating System example | SLOE Labs",
      "description": "Explore the Trade Docs Agentic Operating System example. Auto-generated commercial invoices, packing lists, USMCA certs \u2014 bilingual, border-ready."
    },
    "/demo/social-media-manager-agentic-os": {
      "title": "Social Media Manager Agentic Operating System example | SLOE Labs",
      "description": "Explore the Social Media Manager Agentic Operating System example. Campaign calendar, content pipeline, approvals, assets, and performance loops for social teams."
    },
    "/demo/oil-gas-operations-agentic-os": {
      "title": "Oil & Gas Operations Agentic Operating System example | SLOE Labs",
      "description": "Explore the Oil & Gas Operations Agentic Operating System example. Asset inspections, maintenance risk, HSE evidence, and field follow-ups in one control room."
    },
    "/demo/ecommerce-ops-agentic-os": {
      "title": "Ecommerce Ops Agentic Operating System example | SLOE Labs",
      "description": "Explore the Ecommerce Ops Agentic Operating System example. Orders, products, inventory alerts, customer issues, and revenue answers from live store data."
    },
    "/demo/recruiting-agentic-os": {
      "title": "Recruiting Agentic Operating System example | SLOE Labs",
      "description": "Explore the Recruiting Agentic Operating System example. Candidate pipeline, interview scheduling, scorecards, resumes, and hiring decisions."
    },
    "/demo/field-service-agentic-os": {
      "title": "Field Service Agentic Operating System example | SLOE Labs",
      "description": "Explore the Field Service Agentic Operating System example. Jobs calendar, dispatch board, service history, parts, photos, and customer updates."
    },
    "/demo/legal-case-agentic-os": {
      "title": "Legal Case Agentic Operating System example | SLOE Labs",
      "description": "Explore the Legal Case Agentic Operating System example. Matters, deadlines, evidence, documents, client updates, and decision-safe workflows."
    },
    "/demo/dental-clinic-agentic-os": {
      "title": "Dental Clinic Agentic Operating System example | SLOE Labs",
      "description": "Explore the Dental Clinic Agentic Operating System example. Appointments, treatment plans, recall lists, patient follow-ups, and admin work queues."
    },
    "/demo/construction-project-agentic-os": {
      "title": "Construction Project Agentic Operating System example | SLOE Labs",
      "description": "Explore the Construction Project Agentic Operating System example. Projects, change orders, vendors, site issues, budgets, photos, and client approvals."
    },
    "/demo/restaurant-ops-agentic-os": {
      "title": "Restaurant Ops Agentic Operating System example | SLOE Labs",
      "description": "Explore the Restaurant Ops Agentic Operating System example. Reservations, staffing, inventory, guest issues, events, reviews, and daily prep."
    },
    "/demo/nonprofit-fundraising-agentic-os": {
      "title": "Nonprofit Fundraising Agentic Operating System example | SLOE Labs",
      "description": "Explore the Nonprofit Fundraising Agentic Operating System example. Donor pipeline, grants, campaign tasks, pledges, receipts, and board reporting."
    },
    "/demo/insurance-broker-agentic-os": {
      "title": "Insurance Broker Agentic Operating System example | SLOE Labs",
      "description": "Explore the Insurance Broker Agentic Operating System example. Policies, renewals, claims, documents, client touchpoints, and compliance receipts."
    },
    "/demo/logistics-dispatch-agentic-os": {
      "title": "Logistics Dispatch Agentic Operating System example | SLOE Labs",
      "description": "Explore the Logistics Dispatch Agentic Operating System example. Shipments, routes, exceptions, carrier updates, documents, and customer notifications."
    },
    "/demo/fitness-coaching-agentic-os": {
      "title": "Fitness Coaching Agentic Operating System example | SLOE Labs",
      "description": "Explore the Fitness Coaching Agentic Operating System example. Clients, check-ins, programs, progress, payments, content, and accountability loops."
    },
    "/demo/saas-customer-success-agentic-os": {
      "title": "SaaS Customer Success Agentic Operating System example | SLOE Labs",
      "description": "Explore the SaaS Customer Success Agentic Operating System example. Accounts, health scores, tickets, renewals, usage signals, and churn prevention."
    },
    "/demo/manufacturing-quality-agentic-os": {
      "title": "Manufacturing Quality Agentic Operating System example | SLOE Labs",
      "description": "Explore the Manufacturing Quality Agentic Operating System example. Work orders, defects, inspections, suppliers, corrective actions, and quality receipts."
    },
    "/demo/auto-dealer-agentic-os": {
      "title": "Auto Dealer Agentic Operating System example | SLOE Labs",
      "description": "Explore the Auto Dealer Agentic Operating System example. Vehicle inventory, leads, test drives, financing, service follow-ups, and sales actions."
    },
    "/demo/education-cohort-agentic-os": {
      "title": "Education Cohort Agentic Operating System example | SLOE Labs",
      "description": "Explore the Education Cohort Agentic Operating System example. Students, cohorts, attendance, assignments, interventions, outcomes, and parent updates."
    },
    "/demo/event-production-agentic-os": {
      "title": "Event Production Agentic Operating System example | SLOE Labs",
      "description": "Explore the Event Production Agentic Operating System example. Events, vendors, run-of-show, budgets, assets, client approvals, and day-of issues."
    },
    "/demo/security-guard-ops-agentic-os": {
      "title": "Security Guard Ops Agentic Operating System example | SLOE Labs",
      "description": "Explore the Security Guard Ops Agentic Operating System example. Sites, shifts, incidents, guard assignments, reports, and client-ready evidence."
    },
    "/demo/mortgage-broker-agentic-os": {
      "title": "Mortgage Broker Agentic Operating System example | SLOE Labs",
      "description": "Explore the Mortgage Broker Agentic Operating System example. Borrowers, lender options, documents, approvals, conditions, and closing readiness."
    },
    "/demo/creator-business-agentic-os": {
      "title": "Creator Business Agentic Operating System example | SLOE Labs",
      "description": "Explore the Creator Business Agentic Operating System example. Content pipeline, offers, brand deals, audience insights, repurposing, and revenue tasks."
    },
    "/demo/short-stay-hospitality-agentic-os": {
      "title": "Short-Stay Hospitality Agentic Operating System example | SLOE Labs",
      "description": "Explore the Short-Stay Hospitality Agentic Operating System example. Properties, bookings, turnovers, guest issues, maintenance, reviews, and owner reports."
    }
  }
};
export const publicPages: Record<string, { title: string; description: string }> = publicSite.pages;
const escape = (value: string) => value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
export function publicHead(pathname: string): string {
  const page = publicPages[pathname];
  if (!page) return '';
  const url = publicSite.origin + pathname;
  const graph = [
    { '@type': 'Organization', '@id': 'https://www.sloelabs.com/#organization', name: 'SLOE Labs Inc.', url: 'https://www.sloelabs.com/', logo: 'https://www.sloelabs.com/sloe-labs-logo.svg', sameAs: ['https://github.com/SLOELABS-Inc'] },
    { '@type': 'WebSite', '@id': publicSite.origin + '/#website', name: publicSite.name, url: publicSite.origin + '/', publisher: { '@id': 'https://www.sloelabs.com/#organization' } },
  ];
  const data = JSON.stringify({ '@context': 'https://schema.org', '@graph': graph }).replace(/</g, '\\u003c');
  return `<!-- public-metadata:start -->
    <title data-public-metadata>${escape(page.title)}</title>
    <meta data-public-metadata name="description" content="${escape(page.description)}" />
    <link data-public-metadata rel="canonical" href="${url}" />
    <link data-public-metadata rel="describedby" href="${publicSite.origin}/llms.txt" type="text/plain" />
    <meta data-public-metadata property="og:site_name" content="${escape(publicSite.name)}" />
    <meta data-public-metadata property="og:type" content="website" />
    <meta data-public-metadata property="og:title" content="${escape(page.title)}" />
    <meta data-public-metadata property="og:description" content="${escape(page.description)}" />
    <meta data-public-metadata property="og:url" content="${url}" />
    <script data-public-metadata type="application/ld+json">${data}</script>
    <!-- public-metadata:end -->`;
}
